import { ISupportedLanguage } from 'ngx-mat-esign360/public-api';

export function transformToLanguageCodesArray(languages: ISupportedLanguage[]): string[] {
  return languages.map((language) => language.countryCode);
}
